module.exports = __webpack_public_path__ + "img/es-ga.2618e21f.svg";